import { render, staticRenderFns } from "./buttonLogout.vue?vue&type=template&id=619a227e"
import script from "./buttonLogout.vue?vue&type=script&lang=js"
export * from "./buttonLogout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports